// Kunder (en).
window.PlummeI18n.register('en', {
  'sup.archiveBody': 'Move {name} to the archive? The supplier is hidden from active supplier lists, but invoices, payments and history are kept. You can reopen the supplier later.',
  // --------------------------------------------------------------- Customers
  'cust.title': 'Customers',
  'cust.subtitle': 'All your customers in one place',
  'cust.searchPh': 'Search customer or amount',
  'cust.titleHelp': 'Your customer register — every customer with contact details, outstanding amounts and total sales. Tap a customer to see follow-up and invoices.',
  'cust.searchHelp': 'Search customers by name, email, total sales or outstanding amount.',
  'cust.uploadHelp': 'Import customers from a file.',
  'cust.downloadHelp': 'Download the customer list as CSV or Excel.',
  'cust.addHelp': 'Add a new customer with contact details and follow-up status.',
  'cust.filterHelp': 'Filter customers by status (active, prospect, quote sent, on hold), whether they have outstanding amounts, and whether archived customers are shown.',
  'cust.listHelpTitle': 'The customer list',
  'cust.listHelp': 'Each row is one customer with customer number, company number, email, phone, outstanding amount and total sales. Tap a row to open the customer.',
  'cust.filterOther': 'Other',
  'cust.filterWithOutstanding': 'Only with outstanding',
  'cust.filterShowArchive': 'Show archive',
  'cust.archived': 'Archived',
  'cust.followUpInline': 'Follow-up {date}',

  'cust.col.customer': 'Customer',
  'cust.col.number': 'Customer no.',
  'cust.col.org': 'Company no.',
  'cust.col.email': 'Email',
  'cust.col.phone': 'Phone',
  'cust.col.outstanding': 'Outstanding',
  'cust.col.totalSales': 'Total sales',
  'cust.outstandingInline': 'Outstanding {amount}',
  'cust.balance.customerOwes': 'The customer owes you {amount}',
  'cust.balance.youOwe': 'You owe the customer {amount}',
  'cust.balance.settled': 'Settled',

  'cust.followUp': 'Follow-up',
  'cust.followUpHelp': 'Status, next follow-up date, notes and recent activity for the customer. Use the chat button to log a conversation and build a quote.',
  'cust.dialogTitle': 'Customer conversation',
  'cust.dialogHelp': 'Open a conversation with the customer — log messages and build a quote basis you can turn into a quote.',
  'cust.openChat': 'Open chat',
  'cust.startChat': 'Start chat',
  'cust.nextFollowUp': 'Next follow-up',
  'cust.noFollowUpDate': 'No date set',
  'cust.status': 'Status',
  'cust.salesTitle': 'Sales for this customer',
  'cust.salesHelp': 'All invoices and credit notes for the customer. Filter by all, unpaid or paid — and open an invoice directly with "Open".',
  'cust.salesAll': 'All',
  'cust.salesUnpaid': 'Unpaid',
  'cust.salesPaid': 'Paid',
  'cust.salesTotal': 'Total',
  'cust.noSalesMatch': 'No sales matched the filter.',
  'cust.creditNote': 'Credit note',
  'cust.invoice': 'Invoice',
  'cust.dueOn': 'Due {date}',
  'cust.open': 'Open',
  'cust.pageRange': '{from}-{to} of {total}',
  'cust.prev': 'Previous',
  'cust.next': 'Next',

  'cust.act.newInvoice': 'New invoice',
  'cust.act.newInvoiceHelp': 'Start a new invoice with this customer already selected.',
  'cust.act.edit': 'Edit',
  'cust.act.editHelp': 'Change the customer contact details, status and follow-up.',
  'cust.act.merge': 'Merge',
  'cust.act.mergeHelp': 'Merge two customers that were registered twice — sales and outstanding amounts are combined on one customer.',
  'cust.act.archive': 'Move to archive',
  'cust.act.archiveHelp': 'Hide the customer from active lists. Invoices, payments and history are kept.',
  'cust.act.menu': 'Action',

  'cust.archiveTitle': 'Move to archive?',
  'cust.archiveBody': 'Move {name} to the archive? The customer is hidden from active customer lists, but invoices, payments and history are kept.',
  'cust.archiveStillUsed': 'The customer is still used elsewhere',
  'cust.archiveGroup': '{n} customer group',
  'cust.archiveGroups': '{n} customer groups',
  'cust.archiveSubscription': '{n} subscription',
  'cust.archiveSubscriptions': '{n} subscriptions',
  'cust.archiveAnd': ' and ',

  'cust.merge.title': 'Merge customers',
  'cust.merge.keep': 'Kept',
  'cust.merge.remove': 'Merged and removed',
  'cust.merge.swap': 'Swap which customer is kept',
  'cust.merge.after': 'After merging',
  'cust.merge.name': 'Customer name',
  'cust.merge.totalSales': 'Total sales',
  'cust.merge.notConnected': 'Merging is not connected to the backend yet.',
  'cust.merge.done': 'The customers were merged',
  'cust.merge.failed': 'Could not merge the customers.',

  'cust.form.name': 'Customer name',
  'cust.form.namePh': 'E.g. Example Ltd',
  'cust.form.orgOptional': 'Company number (optional)',
  'cust.form.org': 'Company number',
  'cust.form.address': 'Address',
  'cust.form.addressPh': 'Street address',
  'cust.form.zip': 'Postal code',
  'cust.form.city': 'Postal place',
  'cust.form.cityPh': 'Place',
  'cust.form.crm': 'Customer status',
  'cust.form.nextLabel': 'Next: {date}',
  'cust.form.noFollowUp': 'No follow-up',
  'cust.form.dupTitle': 'Another customer already has this',
  'cust.form.dupName': '{names} has the same name.',
  'cust.form.dupOrg': '{names} has the same organization number.',
  'cust.form.dupEmail': '{names} has the same email address.',
  'cust.form.dupPhone': '{names} has the same phone number.',
  'cust.form.dupUnnamed': 'A customer without a name',
  'cust.form.dupBody': 'The customer is saved as usual. If this is the same customer, you can merge the two from the customer card in the list.',
  'cust.form.contacts': 'Contact persons',
  'cust.form.contactsSub': 'Can be selected as the recipient when you send an invoice, quote or receipt.',
  'cust.form.addContact': 'Add contact person',
  'cust.form.editContact': 'Edit contact person',
  'cust.form.contactFallback': 'Contact person {n}',
  'cust.form.removeContact': 'Remove contact person',
  'cust.form.contactTitle': 'Contact person',
  'cust.form.newTitle': 'New customer',
  'cust.form.editTitle': 'Edit customer',
  'cust.form.saveContact': 'Save',
  'cust.form.contactName': 'Name',
  'cust.form.contactNamePh': 'E.g. Jane Doe',
  'cust.form.contactRole': 'Role',
  'cust.form.contactRolePh': 'E.g. Accounting',
  'cust.form.defaultRef': 'Default invoice reference',
  'cust.form.defaultRefPh': 'E.g. project number, purchase order or department',
  'cust.form.creditLimit': 'Credit limit',
  'cust.form.creditLimitHint': 'Used in reconciliation to measure the customer’s open balance against your own credit policy. A limit never blocks invoicing.',
  'cust.form.creditLimitPh': 'E.g. 60000',
  'cust.form.note': 'Customer note',
  'cust.form.notePh': 'Note about the customer',
  'cust.form.activity': 'Add an activity note',
  'cust.form.activityPh': 'Called the customer, sent a price update…',
  'cust.form.update': 'Update customer',
  'cust.form.save': 'Save customer',

  'cust.crm.prospect': 'Prospect',
  'cust.crm.quoteSent': 'Quote sent',
  'cust.crm.active': 'Active customer',
  'cust.crm.pause': 'On hold',

  'cust.chat.scope.all': 'Whole conversation',
  'cust.chat.scope.to': 'To customer',
  'cust.chat.scope.from': 'From customer',
  'cust.chat.scope.internal': 'Internal notes',
  'cust.chat.helpAll': 'You are seeing the whole conversation.',
  'cust.chat.helpTo': 'You are seeing the messages you have sent.',
  'cust.chat.helpFrom': 'You are seeing messages from the customer.',
  'cust.chat.helpInternal': 'These are your internal notes in the conversation.',
  'cust.chat.threadsHelpTitle': 'Conversations',
  'cust.chat.threadsHelp': 'Each customer can have several conversations. Switch between them here, or start a new one for a new enquiry.',
  'cust.chat.conversation': 'Conversation',
  'cust.chat.filterTitle': 'Filter the conversation',
  'cust.chat.filterHelp': 'Choose what to see in the window below: the whole conversation, messages you have sent, messages from the customer, or internal notes.',
  'cust.chat.windowTitle': 'Conversation window',
  'cust.chat.windowHelp': 'The messages in this conversation. What you send appears on the right, the customer messages and internal notes on the left. Drag the bottom edge to make the window larger.',
  'cust.chat.internal': 'Internal',
  'cust.chat.newInternalTitle': 'New internal note',
  'cust.chat.saveInDialog': 'Save in conversation',
  'cust.chat.saveMessage': 'Save message',
  'cust.chat.sendMessage': 'Send message',
  'cust.chat.newTitle': 'New message',
  'cust.chat.newHelp': 'Write a reply to the customer, paste a message you have received, or note something internally. The selected conversation filter decides whether this is sent to the customer, saved as a customer message, or saved as an internal note.',
  'cust.chat.draftPh': 'Write a reply, paste a customer message, or note what you agreed on...',
  'cust.chat.newDialog': 'New conversation',
  'cust.chat.quoteTitle': 'Quote basis',
  'cust.chat.quoteHelp': 'Add the products and prices you agreed on in the conversation. Press Create quote to turn it into a quote draft with the customer already filled in.',
  'cust.chat.findProduct': 'Find product/price',
  'cust.chat.productPh': 'Search product name...',
  'cust.chat.dragToMessage': 'Drag into the message',
  'cust.chat.dragTotal': 'Drag the total into the message',
  'cust.chat.dragBasis': 'Drag the whole quote basis into the message',
  'cust.chat.quoteBasis': 'Whole basis',
  'cust.chat.remove': 'Remove',
  'cust.chat.total': 'Total',
  'cust.chat.makeQuote': 'Create quote',

  'cust.toast.updated': 'Customer updated',
  'cust.toast.saved': 'Customer saved',
  'cust.toast.saveFailed': 'Could not save the customer.',
  'cust.toast.archived': 'Customer moved to archive',
  'cust.toast.archiveFailed': 'Could not archive the customer.',
  'cust.toast.nothingToExport': 'No customers to export',
  'cust.toast.exportFailed': 'Could not export the customer list.',
  'cust.toast.exported': 'Customer list downloaded',
  'cust.toast.noLedgerRows': 'No ledger lines to export',
  'cust.toast.ledgerExportFailed': 'Could not export the customer ledger.',
  'cust.toast.ledgerExported': 'Customer ledger downloaded',
  'cust.toast.wrongFormat': 'Use CSV or XLSX with the Plumme customer template.',
  'cust.toast.noneInFile': 'Found no customers in the file.',
  'cust.toast.imported': '{n} customers imported',
  'cust.toast.importFailed': 'Could not import the customers.',
  'cust.error.xlsxImport': 'XLSX import is not available yet.',
  'cust.error.xlsxExport': 'Excel export is not available yet.',

  // These headers must normalize to aliases the import parser already accepts
  // (lowercased, spaces/dots/dashes stripped), so an exported file can be
  // re-imported regardless of language. Do not rename without checking
  // parseCustomerMatrix in customers.jsx.
  'cust.export.number': 'Customer number',
  'cust.export.name': 'Name',
  'cust.export.org': 'Organization number',
  'cust.export.email': 'Email',
  'cust.export.phone': 'Phone',
  'cust.export.address': 'Address',
  'cust.export.zip': 'Postal code',
  'cust.export.city': 'Postal place',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Follow up',
  'cust.export.defaultRef': 'Default invoice reference',
  'cust.export.note': 'Note',
  'cust.ledger.code': 'Code',
  'cust.ledger.date': 'Date',
  'cust.ledger.doc': 'Voucher/invoice no.',
  'cust.ledger.type': 'Type',
  'cust.ledger.due': 'Due date',
  'cust.ledger.debit': 'Debit',
  'cust.ledger.credit': 'Credit',
  'cust.ledger.balance': 'Balance after line',
  'cust.ledger.paid': 'Paid',
  'cust.ledger.remaining': 'Remaining',
  'cust.ledger.partial': 'Partly paid',
  'cust.ledger.unpaid': 'Unpaid',
  'cust.ledger.posted': 'Posted',
  'cust.ledger.refund': 'Refund to customer',
  'cust.ledger.payment': 'Customer payment',
  'cust.ledger.creditOverpayment': 'Credit / overpayment',
  'cust.ledger.empty': 'No ledger rows yet.',
  'cust.import': 'Import',
  'cust.importFrom': 'Import from',
  'cust.ledgerShort': 'Ledger',
  'cust.ledger.sheet': 'Customer ledger',
  'cust.sheet.customers': 'Customers',

});
